var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import classNames from 'classnames';
import './videoProgress.scss';
export var VideoProgress = function (props) {
    var currentTime = props.currentTime, downloadRate = props.downloadRate, duration = props.duration, timeRate = props.timeRate, onTimeChange = props.onTimeChange;
    var _a = useState(false), isTimeHover = _a[0], setIsTimeHover = _a[1];
    var _b = useState(0), timeRateHoverPosition = _b[0], setTimeRateHoverPosition = _b[1];
    var handleMouseMove = function (e) {
        if (!isTimeHover) {
            setIsTimeHover(true);
        }
        var elementWidth = e.target.offsetWidth;
        var mouseXRelative = e.clientX - e.target.getBoundingClientRect().x;
        setTimeRateHoverPosition((mouseXRelative / elementWidth) * 100);
    };
    var handleMouseLeave = function (e) {
        setIsTimeHover(false);
    };
    var handleTimeChange = function (e) {
        var timeSelected = duration * (timeRateHoverPosition / 100);
        onTimeChange(timeSelected, currentTime);
    };
    var timeSelectionClassName = classNames('video-controls-time-selector', { 'is-visible': isTimeHover });
    return (_jsxs("div", __assign({ className: 'video-controls-progress-wrapper', onClick: handleTimeChange, onMouseMove: handleMouseMove, onMouseLeave: handleMouseLeave }, { children: [_jsx("div", { className: timeSelectionClassName, style: { transform: "scaleX(".concat(timeRateHoverPosition / 100, ")") } }), _jsx("div", { className: 'video-controls-background-progress' }), _jsx("div", { className: 'video-controls-time-progress', style: { transform: "scaleX(".concat(timeRate / 100, ")") } }), _jsx("div", { className: 'video-controls-load-progress', style: { transform: "scaleX(".concat(downloadRate / 100, ")") } })] })));
};
